/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Capacityattendees1Inputs */

const en_capacityattendees1 = /** @type {(inputs: Capacityattendees1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} attendees`)
};

const de_capacityattendees1 = /** @type {(inputs: Capacityattendees1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Teilnehmer`)
};

/**
* | output |
* | --- |
* | "{count} attendees" |
*
* @param {Capacityattendees1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const capacityattendees1 = /** @type {((inputs: Capacityattendees1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capacityattendees1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capacityattendees1(inputs)
	return de_capacityattendees1(inputs)
});
export { capacityattendees1 as "capacityAttendees" }